/**
 * Route /activities — W1.8
 *
 * Activity-Feed mit Filter-Chips und Pagination.
 */
import { createFileRoute } from '@tanstack/react-router'
import { ActivityFeedPage } from '../features/activity/ActivityFeedPage'

export const Route = createFileRoute('/_auth/activities')({
  component: ActivityFeedPage,
})
